<template>
  <div class="container-widget">
    <div class="px-3 pt-2 pb-2">
      <div class="row justify-content-center">
        <div class="col-12">

          <div class="mt-3 mb-3 text-center">
            <h2>Offshore Leaks Database</h2>
            <p> Find out who’s behind more than 800,000 offshore companies, foundations and trusts from the Pandora Papers, Paradise Papers, Bahamas Leaks, Panama Papers and Offshore Leaks investigations.</p>
          </div>
          
          <div class="search-widget">
            <div class="d-flex">
              <b-form-input class="search-widget__text" v-model="text_search" placeholder="Search the full Offshore Leaks database"></b-form-input>
              <button @click="search" :disabled="text_search.length < 2" class="search-widget__btn btn">SEARCH</button>
            </div>
            <div class="example">
              Example: British Virgin Island, Entity Name LLC.
            </div>
          </div>

          <div class="investigations text-center text-md-left">
            <div class="ml-1 mb-1">Explore by:</div>
            <div class="">
              <ul class="d-sm-flex">
                <li><a target="_blank" href="https://offshoreleaks.icij.org/investigations/pandora-papers">Pandora Papers <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg></a></li>
                <li><a target="_blank" href="https://offshoreleaks.icij.org/investigations/paradise-papers">Paradise Papers <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg></a></li>
                <li><a target="_blank" href="https://offshoreleaks.icij.org/investigations/panama-papers">Panama Papers <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg></a></li>
                <li><a target="_blank" href="https://offshoreleaks.icij.org/investigations/offshore-leaks">Offshore Leaks <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg></a></li>
                <li><a target="_blank" href="https://offshoreleaks.icij.org/investigations/bahamas-leaks">Bahamas Leaks <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg></a></li>
              </ul>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="footer d-flex p-2">
      <div><img class="logo" src="@/assets/icij.png" /></div>
      <div style="min-width: calc(100% - 40px);"><CustomSharingOptions title="Offshore Leaks Database" /></div>
    </div>
  </div> 
  
</template>

<script>

import CustomSharingOptions from '@/components/CustomSharingOptions'

export default {
  name: 'SearchWidget',
  data() {
    return {
      text_search: ``
    }
  },
  components: {
    CustomSharingOptions
  },
  methods: {
    search() {
      window.open(`https://offshoreleaks.icij.org/search?q=${this.text_search}&commit=Search&c=&j=&d=`)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .container-widget  {
    max-width: 820px;
    margin: 0 auto;
    background: #EDEDED;

    h2 {
      text-transform: uppercase;
      font-size: 27px;
      font-weight: 900;
    }

    .search-widget {
      color: #fff;

      &__text {
        width: 100%;
        border-radius: 0;
        border: none;
        padding: 3px;
      }

      &__btn {
        color: #fff;
        border-radius: 0;
        border: none;
        background: #852308;
      }
    }

    .example {
      padding: 10px 0;
      font-size: 15px;
      color: #A7A7A7;
    }

    .footer {
      background-color: #212529;

      .logo {
        max-width: 36px;
      }
    }

    .investigations {
      border-top: dashed 1px #A7A7A7;
      padding: 10px 0;
      font-size: 13px;
      overflow-y: auto;

      ul {
        margin: 0;
        padding: 0;
      }

      li {
        list-style: none;
        flex: 1 1 auto !important;
        
        a {
          padding: 3px 5px;
          color: #333;
          font-weight: 600;
          min-width: 135px;
          display: inline-block;

          &:hover {
            color: #fff;
            background-color: #333;
            text-decoration: none;
          }
        }
      }
    }
  }
</style>
